import { render, staticRenderFns } from "./ConversationMessageItemV2.vue?vue&type=template&id=4c3af616"
import script from "./ConversationMessageItemV2.vue?vue&type=script&lang=js"
export * from "./ConversationMessageItemV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports